import { Usuario } from '../../model/Usuario';
import {  UsuarioService} from '../../service/usuario.service';
import { Component, OnInit } from '@angular/core';
import { ICadBase } from '../../model/ICadBase';
import { State } from '../../model/enumState';
import { MensagemService } from '../../service/mensagem.service';

@Component({
  selector: 'app-cad-usuario',
  templateUrl: './cad-usuario.component.html',
  styleUrls: ['./cad-usuario.component.css']
})
export class CadUsuarioComponent implements ICadBase, OnInit {
  public Vendedores: any;
  public mostrar: boolean = true;
  constructor(public service: UsuarioService, private msg: MensagemService) { }

  title: string = "Usuario";
  titleExcluindo: string = "o usuario";
  nome: string = "usuario"
  ngOnInit() {
    this.service.GetVendedores().subscribe(v=>{
      this.Vendedores = v;
    })
  }

  beforeSave(item, estado: State) {

  }
  public afterSave(item, that, calback) {
    return false;
  }

  NovoItem(item): any {
    var it = new Usuario();
    if (item) {
      it.Assing(item);
    }

    return it;

  }

  public InserindoAssincrono(item, that, calback, CancelLoading) {
    return false;
  }
  public EditandoAssincrono(item, that, calback) {
    return false;
  }

  public validoParaInserir(item): boolean {
    var rt = false;
    if (item.Login) {
      if (item.Nome) {
        if (item.CodTabela) {
          if (item.Email) {
            rt = true;
          }
          else {
            this.msg.Error("E-mail deve ser informado");
          }
        }
        else {
          this.msg.Error("Tabela deve ser informada!");
        }
      }
      else {
        this.msg.Error("Nome deve ser informado")
      }
    }
    else {
      this.msg.Error("Login deve ser informado");
    }
    return rt;
  }
  public validoParaEditar(item): boolean {
    return this.validoParaInserir(item);
  }

  EstadoChange(state: State) {

  }

}
